import React from 'react';
import { BlockStack, Card, Page, Text } from '@shopify/polaris';
import { transformToCdnUrl } from 'utils/google-storage-util';

const Maintenance = () => {
    return (
        <Page>
            <Card padding="800">
                <BlockStack inlineAlign={'center'} gap={'100'}>
                    <img
                        src={transformToCdnUrl('embedded-assets/maintenance-icon/app-maintenance-illustration.webp')}
                        alt="maintenance"
                    />
                    <Text variant="headingMd" as="p">
                        The app is currently under maintenance
                    </Text>
                    <Text variant="bodySm" as="p" tone="subdued">
                        Services will be back soon. Thank you for your patience!
                    </Text>
                </BlockStack>
            </Card>
        </Page>
    );
};

export default Maintenance;
